import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { getUrlParams } from '../../../utils/shared/urlUtils';
import NavigationBar from '../../navigation/NavigationBar';
import { TITLE } from '../../../constants/shared/PMConstants';
import ExternalLinkWrapper from '../../navigation/ExternalLinkWrapper';
import './Progress.scss';
import KeycloakClient from '../../../api/clients/shared/KeycloakClient';

const { PM_TITLE } = TITLE;

const Progress = ({
    selectedPmPeriod,
    licensingInfo,
    location,
    selectedGrowthAnalysisPeriod,
    currentPeriod,
    LinkWrapper,
    getProgressPageConfig,
    ProgressHeaderContainer,
    BasicComprehensionsWebEntryContainer,
    getProgressTabs,
    getMainHelpUrl,
    isBurst,
    gradesWithoutBC,
    gradesWithBC,
    supportedGradesWithBC,
    lrsSwitchProgressTab,
    tablesContainers,
    progressUrl,
}) => {
    const initialProgressPageLoad = useRef(true);
    const { webEntryOpened, progressView: progressTab = PM_TITLE } = getUrlParams(location);
    const isMasUser = KeycloakClient.isMasUser();
    const {
        periods,
        selectedProgressPeriod,
        currentProgressPeriod,
        helpPanelTab,
        helpPanelTitle,
        grid,
    } = getProgressPageConfig({
        progressTab,
        currentPeriod,
        selectedPmPeriod,
        withIntervention: !isMasUser || isBurst,
        selectedGrowthAnalysisPeriod,
        tablesContainers,
    });

    const sendLrsSwitchEvent = () =>
        lrsSwitchProgressTab({
            selectedTab: progressTab,
            selectedPeriod: selectedProgressPeriod,
        });

    useEffect(() => {
        if (!initialProgressPageLoad.current) {
            sendLrsSwitchEvent();
        } else {
            initialProgressPageLoad.current = false;
        }
    }, [progressTab]);

    return (
        <div className="container-wrap">
            <div className="tabs-container space-between">
                <NavigationBar
                    ulTagClassName="nav nav-tabs"
                    onNavigationTabClick={tabId => {
                        if (tabId === progressTab) {
                            sendLrsSwitchEvent();
                        }
                    }}
                    tabs={getProgressTabs(location, progressUrl)}
                    selectedTabId={progressTab}
                    LinkWrapper={LinkWrapper}
                />
                <ExternalLinkWrapper
                    path={`${getMainHelpUrl(licensingInfo)}${helpPanelTab}`}
                    className="btn btn-secondary how-to-read-btn"
                    content={helpPanelTitle}
                />
            </div>
            <div className="progress-container">
                {webEntryOpened && progressTab === PM_TITLE && (
                    <BasicComprehensionsWebEntryContainer
                        panelType={PM_TITLE}
                        supportedGradesWithBC={supportedGradesWithBC}
                        gradesWithoutBC={gradesWithoutBC}
                        gradesWithBC={gradesWithBC}
                    />
                )}
                <ProgressHeaderContainer
                    periods={periods}
                    selectedPeriod={selectedProgressPeriod}
                    currentPeriod={currentProgressPeriod}
                    progressTab={progressTab}
                />
                {grid}
            </div>
        </div>
    );
};

Progress.defaultProps = {
    selectedPmPeriod: '',
    licensingInfo: [],
    location: {},
    selectedGrowthAnalysisPeriod: '',
    currentPeriod: '',
    LinkWrapper: () => {},
    getProgressPageConfig: () => {},
    getProgressTabs: () => {},
    ProgressHeaderContainer: {},
    BasicComprehensionsWebEntryContainer: {},
    isBurst: false,
    lrsSwitchProgressTab: () => {},
    supportedGradesWithBC: null,
    tablesContainers: {},
    progressUrl: '',
};

Progress.propTypes = {
    selectedPmPeriod: PropTypes.string,
    licensingInfo: PropTypes.arrayOf(PropTypes.string),
    location: PropTypes.object,
    selectedGrowthAnalysisPeriod: PropTypes.string,
    currentPeriod: PropTypes.string,
    LinkWrapper: PropTypes.func,
    getProgressPageConfig: PropTypes.func,
    getProgressTabs: PropTypes.func,
    ProgressHeaderContainer: PropTypes.object,
    BasicComprehensionsWebEntryContainer: PropTypes.object,
    getMainHelpUrl: PropTypes.func.isRequired,
    isBurst: PropTypes.bool,
    gradesWithoutBC: PropTypes.array.isRequired,
    gradesWithBC: PropTypes.array.isRequired,
    supportedGradesWithBC: PropTypes.array,
    lrsSwitchProgressTab: PropTypes.func,
    tablesContainers: PropTypes.object,
    progressUrl: PropTypes.string,
};

export default Progress;
